/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Pickup_ErrorInputs */

const vi_qr_pickup_error = /** @type {(inputs: Qr_Pickup_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận đơn thất bại. Kiểm tra lại mã đơn hàng.`)
};

/**

* @param {Qr_Pickup_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_pickup_error = /** @type {((inputs?: Qr_Pickup_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Pickup_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_pickup_error(inputs)
});